import { render } from "./ProductSelector.vue?vue&type=template&id=4ba9602f&scoped=true"
import script from "./ProductSelector.vue?vue&type=script&lang=js"
export * from "./ProductSelector.vue?vue&type=script&lang=js"

import "./ProductSelector.vue?vue&type=style&index=0&id=4ba9602f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4ba9602f"

export default script